import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 108 108",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 108 108\" id=\"close\">\n  <path fill-rule=\"evenodd\" d=\"M80.87 29.958a2 2 0 0 0-2.828-2.828L54 51.172 29.958 27.13a2 2 0 1 0-2.828 2.828L51.172 54 27.13 78.042a2 2 0 0 0 2.828 2.828L54 56.828 78.042 80.87a2 2 0 0 0 2.828-2.828L56.828 54 80.87 29.958Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol